import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setUser } from '../redux/actions/authorization';
import { API_POST } from '../helpers/api';

import Button from '../components/Button';
import { Input } from '../components/Inputs';

export default function Login() {
  const language = navigator.language;
  const dispatch = useDispatch();

  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  function usernameChange(e) {
    setUsername(e.target.value);
  }
  function passwordChange(e) {
    setPassword(e.target.value);
  }
  const submitButton = async () => {
    let res = await API_POST('authentication/login', {
      username: username,
      password: password,
    });
    if (res.status === 200) {
      dispatch(setUser(res.data));
    }
  };
  return (
    <div className='km__p--login'>
      <h4>Login</h4>
      <Input type='text' onChange={usernameChange} id='username' placeholder={language === "tr-TR" ? 'Kullanıcı Adı' : 'Username'}/>
      <Input type='password' onChange={passwordChange} id='password' placeholder={language === "tr-TR" ? 'Şifre' : 'Password'}/>
      <Button onClick={submitButton} label='Login' id='submit' />
      <div className='km__app-version-login'>
        {process.env.REACT_APP_NAME} @{process.env.REACT_APP_VERSION}
      </div>
    </div>
  );
}
